import { useMutation } from '@apollo/client';
import React from 'react';
import TopicIcon from '../topic/TopicIcon';
import type { ReorderableSidebarItem } from './ReorderSidebarItemsModal';
import ReorderSidebarItemsModal from './ReorderSidebarItemsModal';
import { updateSidebarSettingsCache } from './useSidebarSettings';
import { gql } from '../graphql/generated/gql';

const REORDER_MY_TOPICS_MUTATION = gql(`
  mutation ReorderMyTopicIds($topicIds: [ID!]!) {
    updateUserSettings(sidebar: { myTopicIds: $topicIds }) {
      sidebar {
        myTopicIds
      }
    }
  }
`);

interface ReorderMyTopicsModalProps {
  myTopics: ReorderableSidebarItem[];
  close: () => void;
}

const ReorderMyTopicsModal = ({
  myTopics,
  close,
}: ReorderMyTopicsModalProps) => {
  const [reorderMyTopics] = useMutation(REORDER_MY_TOPICS_MUTATION);

  const handleSubmit = async (topicIds: string[]) => {
    await reorderMyTopics({
      variables: { topicIds },
      update: updateSidebarSettingsCache,
    });
    close();
  };

  return (
    <ReorderSidebarItemsModal
      onSubmit={handleSubmit}
      headerIcon={<TopicIcon />}
      header="My Topics"
      title="Reorder My Topics"
      subtitle="Choose the order you want the topics that you are a member of to appear. This preference will only affect you in your My Topics sidebar."
      items={myTopics}
      close={close}
    />
  );
};

export default ReorderMyTopicsModal;
